import actionTypes from './actionTypes'
import config from '../../../config/config'
import { checkJapanese } from '../../../lib'
import moment from 'moment'

const {
  REQUEST_LOGIN,
  RECEIVE_LOGIN_STATUS,
  ERROR_OCURED,
  AUTH_ERRORS,
  FORET_PASS_ERROR,
  RESET_PASSWORD,
  SET_SHOULD_RESET,
  LOGIN_STATUS,
  SET_MAX_LOGIN_ATTEMPT,
  RESET_ERROR
} = actionTypes

let maxNumberOfLoginAttempts = 3, minutesToWait = 5;

function requestLogin() {
  return {
    type: REQUEST_LOGIN
  }
}

function hasErrored(bool) {
  return {
    type: ERROR_OCURED,
    hasErrored: bool
  }
}

export function getresponse(res, email, password, remember, dispatch, noOfLoginAttempts, lastLoginAttemptAt) {
  if (res.status && res.status === 'success') {
    resetLoginAttemptCount(email)
    localStorage.setItem('loginEmail', email)
    localStorage.setItem('loginPassword', password)
    if (!remember) {
      localStorage.setItem('authToken', res.data.token)
      dispatch(recieveLoginstatus(true, res.data.user))
      dispatch(checkLoggedIn(true))
    } else {
      localStorage.setItem('authToken', res.data.token)
      dispatch(recieveLoginstatus(true, res.data.user))
      dispatch(checkLoggedIn(true))
    }
  } else if (res.errors) {
    if(noOfLoginAttempts >= maxNumberOfLoginAttempts && lastLoginAttemptAt < minutesToWait) {
      dispatch(resetError())
      dispatch(setMaxLoginAttempt(true));
    } else {
      dispatch(authErrors(res.errors))
      dispatch(checkLoggedIn(false))
    }
    console.error(res.errors);
  }
}

export function authErrors(errors) {
  return { type: AUTH_ERRORS, errors }
}

export function resetError() {
  return {
    type: RESET_ERROR
  }
}

export function setMaxLoginAttempt(status) {
  return {
    type: SET_MAX_LOGIN_ATTEMPT,
    status
  }
}

export function recieveLoginstatus(bool, user) {
  return {
    type: RECEIVE_LOGIN_STATUS,
    success: bool,
    user
  }
}

export function checkLoggedIn(bool) {
  return {
    type: LOGIN_STATUS,
    isLoggedIn: bool
  }
}
export function loginUser(email, password, remember) {
  return function (dispatch) {
    dispatch(requestLogin())
    let count = 0, lastLoginAttemptAt = 0;
    let loginAttempts = localStorage.getItem('login_attempts');
    if(loginAttempts){
      loginAttempts = JSON.parse(loginAttempts);
      let currentUser = loginAttempts.find(session => session.email === email);
      if(currentUser) {
        count = currentUser.count;
        const startTime = moment(moment(currentUser.time), 'DD-MM-YYYY hh:mm:ss');
        const endTime = moment(new Date(), 'DD-MM-YYYY hh:mm:ss');
        lastLoginAttemptAt = endTime.diff(startTime, 'minutes');
      }
    }

     const payload = {
      email,
      password,
      count: count
    };

    if(count >= maxNumberOfLoginAttempts && lastLoginAttemptAt < minutesToWait) {
      dispatch(setMaxLoginAttempt(true));
      dispatch(resetError());
    } else {
      dispatch(setMaxLoginAttempt(false));
      let myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json;charset=UTF-8')
      return fetch(`${config.URI}/api/v1/login`, {
        method: 'post',
        headers: myHeaders,
        body: JSON.stringify(payload)
      })
        .then(res => {
          if (!res.ok) {
            throw Error(res.statusText)
          } else {
            return res.json()
          }
        })
        .then(res => {
          if (res.errors) {
            if(res.errors && res.errors.toLowerCase() === 'invalid email/password combination') {
              handleInvalidLoginAttempt(email, lastLoginAttemptAt)
            }
            if (res.errors.message) {
              alert(res.errors.message)
              window.location.href = res.errors.redirect_url
            }
            getresponse(res, email, password, remember, dispatch, count + 1, lastLoginAttemptAt)
          }
          else if (!res.data.user.fvdomain_id) {
            let warning = checkJapanese() ? 'このユーザーにはfvliteドメインがありません' : 'This user has no fvlite domain';
            alert(warning)
          }
          else {
            getresponse(res, email, password, remember, dispatch, 0, 0)
          }
        })
        .catch((error) => {
          dispatch(hasErrored(true))
          
          console.error(error);
        })
    }
  }
}

function handleInvalidLoginAttempt(email, lastLoginAttemptAt) {
  let loginAttempts = localStorage.getItem("login_attempts");
  if(loginAttempts) {
    loginAttempts = JSON.parse(loginAttempts);
    let currentUser = loginAttempts.find(session => session.email === email);
    if(currentUser) {
      // Resets the counts If last login was 5 mins ago
      currentUser.count = lastLoginAttemptAt < minutesToWait ? currentUser.count + 1 : 1;
      // Sets the last login time
      currentUser.time = moment().toDate();
      loginAttempts = loginAttempts.map(session => {
        if(session.email === currentUser.email) {
          session = currentUser;
        }
        return session;
      })
      localStorage.setItem('login_attempts', JSON.stringify(loginAttempts));
    } else {
      createNewLoginAttemptSession(email);
    }
  } else {
    createNewLoginAttemptSession(email);
  }
}

function createNewLoginAttemptSession(email) {
  let loginAttempts = localStorage.getItem('login_attempts');
  loginAttempts = loginAttempts ? JSON.parse(loginAttempts) : [];
  const loginAttempt = {
    email,
    count: 1,
    time: moment().toDate()
  };
  loginAttempts.push(loginAttempt);
  localStorage.setItem('login_attempts', JSON.stringify(loginAttempts));
}

function resetLoginAttemptCount(email) {
  let loginAttempts = localStorage.getItem('login_attempts');
  loginAttempts = loginAttempts ? JSON.parse(loginAttempts) : [];
  let currentUser = loginAttempts.find(session => session.email === email);
  if(currentUser) {
    currentUser.count = 0;
    loginAttempts = loginAttempts.map(session => {
      if(session.email === currentUser.email) {
        session = currentUser;
      }
      return session;
    });
    localStorage.setItem('login_attempts', JSON.stringify(loginAttempts));
  }
}

export function setShouldResetPassword(bool) {
  return {
    type: SET_SHOULD_RESET,
    shouldResetPassword: bool
  }
}

export function resetPassword(email) {
  return function (dispatch) {
    const payload = {
      email,
      service_name: 'fvlite'
    }
    let myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json;charset=UTF-8')
    return fetch(`${config.URI}/api/v1/password_reset`, {
      method: 'post',
      headers: myHeaders,
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch({ type: RESET_PASSWORD })
        } else if (res.errors) {
          dispatch({ type: FORET_PASS_ERROR })
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        
        console.error(error);
      })

  }
}



// WEBPACK FOOTER //
// src/routes/Login/actions/index.js